import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import Loading from 'uI/Loading/Loading';
import LoginForm from 'components/LoginForm/LoginForm';
import FormContainer from 'uI/FormContainer/FormContainer';

import { addUserByGroup, groupInfo } from 'store/invite-actions';
import { logOut } from 'store/user-actions';

import classes from './Invite.module.css';

const Invite = () => {
  const { t } = useTranslation(['login']);
  const { idGroup } = useParams();
  const [load, setLoad] = useState(true);
  const [groupData, setgroupData] = useState('');
  const [success, setSuccess] = useState(false);
  const dataUser = useSelector(state => state.userInfo);

  useEffect(() => {
    (async () => {
      setgroupData(await groupInfo(idGroup));
      setLoad(false);
    })();
  }, []);

  const logoutUser = () => {
    logOut(`invite/${idGroup}`);
  };

  const addUserHandler = () => {
    setLoad(true);
    (async () => {
      const add = await addUserByGroup(idGroup);
      if (add) {
        setSuccess(true);
      } else {
        setSuccess('error');
      }
      setLoad(false);
    })();
  };

  return (
    <>
      {dataUser.data.systemDate &&
        (dataUser.data.usuario ? (
          <Paper className={classes.inviteContainer} elevation={1}>
            <p className={classes.title}>
              {success === 'error'
                ? 'Ya te habías inscrito previamente al grupo. Da clic al botón continuar para ver tus cursos'
                : success
                ? 'Quedaste inscrito al grupo. Da clic al botón continuar para ver tus cursos'
                : 'Te estás dando de alta al grupo:'}
            </p>
            <div className={classes.groupInfoContainer}>
              <p className={classes.groupName}>{groupData.name}</p>
              <p className={classes.groupDescription}>
                {groupData.description}
              </p>
            </div>
            {!success && (
              <div className={classes.userInfoContainer}>
                <p className={classes.titleUser}>
                  El registro de tu inscripción se realizará con tu
                  cuenta:
                </p>
                <p>
                  <span className={classes.item}>Nombre:</span>{' '}
                  {dataUser.data.nombre} {dataUser.data.apellido}
                </p>
                <p>
                  <span className={classes.item}>
                    Correo electrónico:
                  </span>{' '}
                  {dataUser.data.email}
                </p>
                <aside className={classes.logOutContainer}>
                  <p className={classes.logOutText}>¿No eres tú?</p>
                  <Button
                    onClick={logoutUser}
                    className={classes.logOutBtn}
                  >
                    Salir
                  </Button>
                </aside>
              </div>
            )}
            <div className={classes.btnContainer}>
              {!load ? (
                success ? (
                  <Button
                    className={classes.validateBtn}
                    component={Link}
                    to="/campus/myCourses"
                  >
                    Continuar
                  </Button>
                ) : (
                  <Button
                    className={classes.validateBtn}
                    onClick={addUserHandler}
                  >
                    Continuar
                  </Button>
                )
              ) : (
                <Loading />
              )}
            </div>
          </Paper>
        ) : (
          <FormContainer
            title={t('principal_text')}
            btnLink="register"
            login
          >
            <LoginForm prevUrl={`invite/${idGroup}`} />
          </FormContainer>
        ))}
    </>
  );
};

export default Invite;
